module.exports = __webpack_public_path__ + "img/xiaomi12timage2mobile.9cdde28f.png";